import { Block, BlockAction } from '../types/panel'
import AlertBlock from './blocks/AlertBlock'
import BarBlock from './blocks/BarBlock'
import DetailBlock from './blocks/DetailBlock'
import DonutBlock from './blocks/DonutBlock'
import KpiBlock from './blocks/KpiBlock'
import LineBlock from './blocks/LineBlock'
import TableBlock from './blocks/TableBlock'

interface Props {
  blocks: Block[]
  onAction?: (action: BlockAction) => void
}

export default function BlockRenderer({ blocks, onAction }: Props) {
  const safeBlocks = Array.isArray(blocks) ? blocks : []
  return (
    <>
      {safeBlocks.map((block, i) => {
        switch (block.type) {
          case 'alert':  return <AlertBlock  key={i} block={block} onAction={onAction} />
          case 'bar':    return <BarBlock    key={i} block={block} />
          case 'detail': return <DetailBlock key={i} block={block} onAction={onAction} />
          case 'donut':  return <DonutBlock  key={i} block={block} />
          case 'kpi':    return <KpiBlock    key={i} block={block} onAction={onAction} />
          case 'line':   return <LineBlock   key={i} block={block} />
          case 'table':  return <TableBlock  key={i} block={block} />
          default:       return null
        }
      })}
    </>
  )
}
